/**
 * The public documentation site's own header and footer.
 *
 * WHY IT IS NOT `PublicNav`. That nav belongs to a CLEANING COMPANY: it offers
 * "Get a quote" and three tenant portal logins, and on mount it fetches
 * `/api/public/active-crew` to show who is working. All three are wrong on
 * help.broomstack.app — the vendor's own manual is not selling a clean, has no
 * portals of its own, and deliberately resolves no tenant, so the crew fetch
 * 404'd on every single page load.
 *
 * Found in a real browser by nlc-46 after the hydration fix landed: the brand
 * name and colours were correct (the short-circuit in root.tsx held), and the
 * CHROME around them still belonged to a customer. Two different leaks wearing
 * the same clothes.
 *
 * So the docs host gets chrome of its own: no CTA, no portals, no tenant
 * fetches. Just a way back to the index and a link into the product.
 */

import { Link } from 'react-router';

export function DocsNav() {
  return (
    <header className="docs-nav">
      <div className="container-narrow docs-nav-inner">
        <Link to="/" className="docs-nav-brand">
          Broomstack <span className="docs-nav-brand-sub">Help</span>
        </Link>
        <nav aria-label="Documentation">
          <a href="https://broomstack.app" className="docs-nav-link">
            broomstack.app
          </a>
        </nav>
      </div>
    </header>
  );
}

export function DocsFooter() {
  return (
    <footer className="docs-footer">
      <div className="container-narrow">
        <p>
          Documentation for Broomstack, software for cleaning companies. Signed in already?
          Your help centre is in your own console under <strong>More → Help</strong>.
        </p>
      </div>
    </footer>
  );
}
